<template>
  <a-layout style="min-height: 100vh">
    <a-layout-sider v-model="collapsed" collapsible :trigger="null" width="220">
      <div class="brand" @click="goHome">
        <div class="brand-logo"><img src="/logo.png" alt="桨刻" /></div>
        <transition name="fade">
          <div v-if="!collapsed" class="brand-text">
            <div class="brand-name">桨刻体育</div>
            <div class="brand-sub">JIANGK SPORTS</div>
          </div>
        </transition>
      </div>
      <a-menu theme="dark" :default-selected-keys="[$route.path]" mode="inline" :inline-collapsed="collapsed">
        <template v-for="item in routes">
          <template v-if="!item.hidden">

            <a-menu-item 
              v-if="isSingleItem(item)" 
              :key="resolveKey(item)"
              @click="handleSingleClick(item)"
            >
              <a-icon :type="getIcon(item)" />
              <span>{{ getTitle(item) }}</span>
            </a-menu-item>

            <a-sub-menu 
              v-else 
              :key="item.path"
            >
              <span slot="title">
                <a-icon :type="item.meta && item.meta.icon ? item.meta.icon : 'appstore'" />
                <span>{{ item.meta && item.meta.title ? item.meta.title : '未命名' }}</span>
              </span>
              <template v-for="child in item.children">
                <a-menu-item v-if="!child.hidden" :key="resolvePath(item.path, child.path)"
                  @click="handleMenuClick(item.path, child.path)">
                  <span>{{ child.meta && child.meta.title ? child.meta.title : child.name }}</span>
                </a-menu-item>
              </template>
            </a-sub-menu>

          </template>
        </template>
      </a-menu>
    </a-layout-sider>

    <a-layout>
      <a-layout-header class="topbar">
        <div class="topbar-left">
          <a-icon 
            class="trigger" 
            :type="collapsed ? 'menu-unfold' : 'menu-fold'" 
            @click="() => (collapsed = !collapsed)" 
          />
          <span class="page-title">{{ pageTitle }}</span>
        </div>
        <div class="topbar-right">
        <a-dropdown placement="bottomRight" :visible="noticeVisible" @visibleChange="onNoticeVisibleChange">
          <a-badge :count="noticeTotal" :overflow-count="99" :offset="[-4, 4]">
            <div class="notice-trigger">
              <a-icon type="bell" style="font-size:18px; color:#2C3A4B;" />
            </div>
          </a-badge>
          <div slot="overlay" class="notice-panel">
            <div class="notice-head">
              <span>待办与通知</span>
              <a style="font-size:12px;" @click="loadNotice">刷新</a>
            </div>
            <div class="notice-body">
              <div class="notice-item" v-if="notice.authPending > 0" @click="goNotice('/dragonboat/auth/verifications')">
                <span class="dot orange"></span>
                <span class="notice-text">实名认证待审 <b>{{ notice.authPending }}</b> 条</span>
                <span class="arrow">›</span>
              </div>
              <div class="notice-item" v-if="notice.cancelPending > 0" @click="goNotice('/dragonboat/auth/cancel-review')">
                <span class="dot red"></span>
                <span class="notice-text">注销账号待审 <b>{{ notice.cancelPending }}</b> 条</span>
                <span class="arrow">›</span>
              </div>
              <div class="notice-item" v-if="notice.pendingRegistration > 0" @click="goNotice('/dragonboat/registration')">
                <span class="dot blue"></span>
                <span class="notice-text">报名申请待审 <b>{{ notice.pendingRegistration }}</b> 条</span>
                <span class="arrow">›</span>
              </div>
              <div class="notice-item" v-if="notice.pendingTeam > 0" @click="goNotice('/dragonboat/team')">
                <span class="dot purple"></span>
                <span class="notice-text">俱乐部入驻待审 <b>{{ notice.pendingTeam }}</b> 家</span>
                <span class="arrow">›</span>
              </div>
              <div class="notice-item" v-if="notice.total === 0" style="cursor:default; color:#999;">暂无待办，一切正常</div>
            </div>
            <div class="notice-head" style="border-top:1px solid #f0f0f0;">
              <span>新赛事</span>
            </div>
            <div class="notice-body">
              <div class="notice-item" v-for="ev in notice.events" :key="ev.id" @click="goNotice(`/dragonboat/event/workbench?eventId=${ev.id}`)">
                <span class="dot green"></span>
                <span class="notice-text">{{ ev.title }}<span class="ev-time" v-if="ev.eventTime"> · {{ ev.eventTime }}</span></span>
                <span class="arrow">›</span>
              </div>
              <div class="notice-item" v-if="!notice.events || !notice.events.length" style="cursor:default; color:#999;">暂无赛事</div>
            </div>
          </div>
        </a-dropdown>
        <a-dropdown>
          <div class="user-box">
            <a-avatar size="small" style="background:#4ECDC4;">管</a-avatar>
            <span class="user-name">管理员</span>
            <a-icon type="down" style="font-size:12px; color:#7A8A9A;" />
          </div>
          <a-menu slot="overlay">
            <a-menu-item @click="handleLogout">
              <a-icon type="logout" /> 退出登录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        </div>
      </a-layout-header>

      <a-layout-content class="page-container">
        <router-view />
      </a-layout-content>

      <a-layout-footer class="site-footer">
        <span>桨刻体育 · 龙舟赛事数据资产平台</span>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >粤ICP备2023117792号-3</a>
      </a-layout-footer>
    </a-layout>
    
  </a-layout>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        collapsed: false,
        noticeVisible: false,
        notice: { authPending: 0, cancelPending: 0, pendingRegistration: 0, pendingTeam: 0, total: 0, events: [] }
      }
    },
    mounted() {
      this.loadNotice()
    },
    computed: {
      ...mapState({
        routes: state => state.routes
      }),
      pageTitle() {
        const route = this.$route
        return route.meta && route.meta.title ? route.meta.title : '桨刻管理后台'
      },
      noticeTotal() {
        return Number(this.notice.total) || 0
      }
    },
    methods: {
      loadNotice() {
        import('@/api').then(({ getDashboardTodo }) => getDashboardTodo().then(res => {
          this.notice = Object.assign({ authPending: 0, cancelPending: 0, pendingRegistration: 0, pendingTeam: 0, total: 0, events: [] }, res.data || {})
        }).catch(() => {}))
      },
      onNoticeVisibleChange(visible) {
        this.noticeVisible = visible
        if (visible) this.loadNotice()
      },
      goNotice(path) {
        this.noticeVisible = false
        this.$router.push(path)
      },
      isSingleItem(item) {
        // 1. 如果没有 children -> 单菜单
        if (!item.children || item.children.length === 0) {
          return true;
        }
        // 2. 如果是根路径 "/" 且只有一个子节点 -> 也是单菜单 (Dashboard情况)
        if (item.path === '/' && item.children.length === 1) {
          return true;
        }
        // 3. 顶层页面菜单（后端提升的顶级菜单）：children 都是空路径包装 -> 单菜单
        if (item.children.every(c => !c.path)) {
          return true;
        }
        return false;
      },

      getTitle(item) {
        if (item.path === '/' && item.children && item.children.length === 1) {
          return item.children[0].meta?.title || item.children[0].title;
        }
        return item.meta?.title || item.title;
      },

      getIcon(item) {
        if (item.path === '/' && item.children && item.children.length === 1) {
          return item.children[0].meta?.icon || item.children[0].icon || 'desktop';
        }
        return item.meta?.icon || item.icon || 'desktop';
      },

      resolveKey(item) {
        if (item.path === '/' && item.children && item.children.length === 1) {
          return this.resolvePath(item.path, item.children[0].path);
        }
        return item.path;
      },

      handleSingleClick(item) {
        let targetPath = item.path;
        if (item.path === '/' && item.children && item.children.length === 1) {
          targetPath = this.resolvePath(item.path, item.children[0].path);
        }
        if (this.$route.path !== targetPath) {
          this.$router.push(targetPath);
        }
      },

      resolvePath(basePath, routePath) {
        if (!routePath) return basePath;
        if (basePath.endsWith('/')) return basePath + routePath;
        return basePath + '/' + routePath;
      },

      handleMenuClick(basePath, routePath) {
        const fullPath = this.resolvePath(basePath, routePath);
        if (this.$route.path !== fullPath) {
          this.$router.push(fullPath);
        }
      },

      handleLogout() {
        this.$store.dispatch('Logout');
      },
      goHome() {
        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
      }
    }
  }
</script>

<style scoped>
.brand {
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  background: #131F2A;
  cursor: pointer;
  overflow: hidden;
}

.brand-logo {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 9px;
  overflow: hidden;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(78, 205, 196, 0.4);
}

.brand-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.brand-text {
  margin-left: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

.brand-name {
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 2px;
}

.brand-sub {
  background: linear-gradient(90deg, #4ECDC4, #B8FFF6, #4ECDC4, #2FBFB5, #4ECDC4);
  background-size: 220% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 10px;
  letter-spacing: 2.5px;
  font-weight: 600;
  animation: brandGlow 4s linear infinite;
  filter: drop-shadow(0 0 6px rgba(78, 205, 196, 0.65));
}

@keyframes brandGlow {
  0% { background-position: 0% center; }
  100% { background-position: 220% center; }
}

.brand-logo {
  box-shadow: 0 4px 10px rgba(78, 205, 196, 0.4), 0 0 18px rgba(78, 205, 196, 0.35);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.trigger {
  font-size: 18px;
  cursor: pointer;
  color: #7A8A9A;
}

.trigger:hover {
  color: #4ECDC4;
}

.page-title {
  color: #2C3A4B;
  font-size: 15px;
  font-weight: 600;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notice-trigger {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #F4FAFA;
  border: 1px solid #E3EEF2;
  transition: all 0.2s;
}

.notice-trigger:hover {
  background: #E7F7F5;
  border-color: #4ECDC4;
  box-shadow: 0 0 12px rgba(78, 205, 196, 0.35);
}

.notice-panel {
  width: 320px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(20, 40, 60, 0.14);
  overflow: hidden;
  border: 1px solid #E9F0F5;
}

.notice-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #2C3A4B;
  background: #FAFCFE;
}

.notice-body {
  max-height: 260px;
  overflow-y: auto;
}

.notice-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  cursor: pointer;
  border-bottom: 1px solid #F5F7FA;
  transition: background 0.15s;
}

.notice-item:hover {
  background: #F4FAFA;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dot.orange { background: #FF8F00; box-shadow: 0 0 6px rgba(255,143,0,0.5); }
.dot.red { background: #FF4D4F; box-shadow: 0 0 6px rgba(255,77,79,0.5); }
.dot.blue { background: #4A9EF5; box-shadow: 0 0 6px rgba(74,158,245,0.5); }
.dot.purple { background: #722ED1; box-shadow: 0 0 6px rgba(114,46,209,0.5); }
.dot.green { background: #52C41A; box-shadow: 0 0 6px rgba(82,196,26,0.5); }

.notice-text {
  flex: 1;
  font-size: 13px;
  color: #2C3A4B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-text b {
  color: #FF4D4F;
}

.ev-time {
  color: #999;
  font-size: 12px;
}

.notice-item .arrow {
  color: #B8C4CE;
  font-size: 13px;
}

.user-box {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s;
}

.user-box:hover {
  background: #F4FAFA;
}

.user-name {
  color: #2C3A4B;
  font-size: 14px;
}

.page-container {
  margin: 16px;
  padding: 0;
}

.page-container > * {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #E4EDF2;
  box-shadow: 0 2px 10px rgba(22, 35, 47, 0.04);
  padding: 20px;
}

.site-footer {
  padding: 10px 16px 16px;
  color: #8c8c8c;
  background: transparent;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.site-footer a {
  color: inherit;
}

.site-footer a:hover {
  color: #4ECDC4;
}
</style>
